<template>
  <div class="collage-carousel">
    
    <div class="collage-grid">
      <div
        v-for="(image, index) in images"
        :key="index"
        :ref="el => setCollageItem(el, index)"
        class="collage-item"
        :class="{ visible: imageVisible[index] }"
        @click="enlargeImage(index)"
      >
        <img
          :src="image"
          class="collage-image"
          :alt="'Imagen ' + index"
        >
      </div>
    </div>

    <!-- Modal con transiciones dinámicas modernas -->
    <div
      v-if="isImageEnlarged"
      class="image-modal"
      @click="closeModal"
      ref="modalRef"
    >
      <img
        :src="images[currentIndex]"
        class="enlarged-image"
        ref="modalImageRef"
      >

    </div>

  </div>                    <div class="rasgado rasgado-inferior"></div>

</template>

<script>
import { ref, onMounted, nextTick } from 'vue'
import gsap from 'gsap'

export default {
  name: 'CollageAnimado',
  setup() {
    const images = [
      require('@/assets/imagensegunda.webp'),
    ]

    const currentIndex = ref(0)
    const isImageEnlarged = ref(false)
    const collageItems = ref([])
    const imageVisible = ref(new Array(images.length).fill(false))
    
    // Referencias para animar el Modal Moderno
    const modalRef = ref(null)
    const modalImageRef = ref(null)

    const setCollageItem = (el, index) => {
      collageItems.value[index] = el
    }

    const enlargeImage = async (index) => {
      currentIndex.value = index
      isImageEnlarged.value = true
      
      // Esperamos a que el modal se renderice en el DOM para animarlo con GSAP
      await nextTick()
      if (modalRef.value && modalImageRef.value) {
        gsap.fromTo(modalRef.value, 
          { opacity: 0 }, 
          { opacity: 1, duration: 0.3, ease: 'power2.out' }
        )
        gsap.fromTo(modalImageRef.value, 
          { scale: 0.7, y: 30, rotation: -2 }, 
          { scale: 1, y: 0, rotation: 0, duration: 0.5, ease: 'back.out(1.5)' }
        )
      }
    }

    const closeModal = () => {
      // Animación estética de salida antes de destruir el modal
      if (modalRef.value && modalImageRef.value) {
        gsap.to(modalImageRef.value, {
          scale: 0.8,
          opacity: 0,
          y: 40,
          duration: 0.3,
          ease: 'power2.in',
          onComplete: () => {
            isImageEnlarged.value = false
          }
        })
        gsap.to(modalRef.value, { opacity: 0, duration: 0.3 })
      } else {
        isImageEnlarged.value = false
      }
    }

    const observeImages = () => {
      const options = { threshold: 0.15 } // Umbral optimizado para detectar la caída justo a tiempo

      const observer = new IntersectionObserver((entries) => {
        entries.forEach((entry) => {
          const index = collageItems.value.indexOf(entry.target)
          if (entry.isIntersecting) {
            imageVisible.value[index] = true
            animateIn(entry.target, index)
            observer.unobserve(entry.target)
          }
        })
      }, options)

      collageItems.value.forEach((el) => el && observer.observe(el))
    }

    // --- NUEVA ANIMACIÓN DE ENTRADA: EFECTO CAÍDA FLUIDA Y MODERNA ---
    const animateIn = (el, index) => {
      // Alterna ligeras rotaciones hacia la izquierda o derecha al caer para que se vea orgánico
      const randomRotation = index % 2 === 0 ? -6 : 6
      
      gsap.fromTo(el,
        { 
          y: -120,          // Cae desde arriba hacia su posición original
          opacity: 0, 
          scale: 0.85, 
          rotation: randomRotation,
          transformOrigin: "center top"
        },
        {
          y: 0,
          opacity: 1,
          scale: 1,
          rotation: 0,
          duration: 1.4,
          delay: index * 0.15, // Delay en cascada elegante progresivo
          ease: 'back.out(1.3)' // Atenuación con un rebote de frenado muy suave y moderno
        }
      )
    }

    onMounted(async () => {
      await nextTick()
      observeImages()
    })

    return {
      images,
      currentIndex,
      isImageEnlarged,
      enlargeImage,
      closeModal,
      collageItems,
      imageVisible,
      setCollageItem,
      modalRef,
      modalImageRef
    }
  }
}
</script>

<style scoped>
.collage-carousel {
  width: 100%;
  max-width: 100%;
  padding: -80px 0;
  background-color: rgb(255, 255, 255);
  margin: 0;
  display: flex;
  justify-content: center;
}

.collage-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(280px, 1fr));
  gap: 35px;
  width: 90%; /* Mantenido estrictamente al 90% */
  max-width: 1200px;
}

.collage-item {
  border: none;
  border-radius: 20px; /* Bordes un poco más curvos y modernos */
  overflow: hidden;
  background-color: #fff;
  box-shadow: 0 15px 35px rgba(0, 0, 0, 0.18);
  transform-origin: center top;
  opacity: 0;
  cursor: pointer;
  will-change: transform, opacity;
  transition: box-shadow 0.4s ease;
}

/* Sutil hover moderno de elevación y cambio de sombreado */
.collage-item:hover {
  box-shadow: 0 22px 45px rgba(0, 0, 0, 0.28);
}

.collage-item.visible {
  opacity: 1;
}

.collage-image {
  width: 100%;
  height: auto;
  object-fit: cover;
  display: block;
  transition: transform 0.5s cubic-bezier(0.25, 1, 0.5, 1);
}

/* Hover de zoom cinemático y suave dentro de la tarjeta */
.collage-item:hover .collage-image {
  transform: scale(1.06);
}

.rasgado{
  position:absolute;
  left:0;
  width:100%;
  height:50px;
  background:#000000;
  z-index:3;
  margin-top:-40px;
  pointer-events:none;
}

.rasgado-superior{
  top:0;

  clip-path: polygon(
    0% 80%, 25% 60%, 50% 85%, 75% 55%, 100% 75%,
    100% 0%, 0% 0%
  );
}

.rasgado-inferior{
  bottom:0; background-color: #000000;
  clip-path: polygon(
    0% 20%, 25% 40%, 50% 15%, 75% 45%, 100% 25%,
    100% 100%, 0% 100%
  );
}
.image-modal {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(10, 10, 10, 0.88);
  backdrop-filter: blur(8px); /* Blur de fondo estilizado para la interfaz de usuario */
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 999;
}

.enlarged-image {
  max-width: 90%;
  max-height: 85%;
  border-radius: 16px;
  object-fit: contain;
  box-shadow: 0 25px 60px rgba(0, 0, 0, 0.6);
}
</style>